// Lib imports
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { loadedPersistedState } from '@/store/plugins/perssist'

// Routes
import routes from './routes'

const isStateLoaded = loadedPersistedState()

Vue.use(Router)

// Create a new router
const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach( async (to, from, next) => {

  await isStateLoaded

  if (to.path === '/login' && to.query.token) {
    return next()
  }

  if (to.matched.some(route => route.meta.auth) && !store.getters['auth/isLoggedIn']) {
    return next('/login')
  }

  if (to.matched.some(route => route.meta.guest) && store.getters['auth/isLoggedIn']) {
    return next('/dashboard')
  }

  if (to.matched.some(route => route.meta.admin) && !store.getters['auth/isAdmin']) {
    return next(false)
  }

  return next()
})

router.afterEach( (to) => {
  const meta = to.matched.reduce((acc, route) => {
    return {
      ...acc,
      ...route.meta
    }
  }, {})

  if (meta.title) {
    document.title = `${meta.title} - ${router.app.$appName}`
  } else {
    document.title = router.app.$appName
  }
})

export default router
